import { Component, inject, OnInit } from '@angular/core';
import { NgFor, NgIf, NgStyle } from '@angular/common';
import { PaymentService } from '../services/payment.service';
import { PaymentMethod } from '../shared/interfaces/payment-method';
import { CurrencyPipe } from '@angular/common';
import { QRCodeModule } from 'angularx-qrcode';
import { ActivatedRoute, RouterLink, Router } from '@angular/router';
import { LinkService } from '../shared/services/link.service';
import { LinkInformation } from '../shared/interfaces/link-information';
import { LinkStatus } from '../shared/enums/link-status';
import { PusherService } from '../services/pusher.service';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [NgFor,NgIf, QRCodeModule, CurrencyPipe, NgStyle, RouterLink],
  templateUrl: './home.component.html',
  styleUrl: './home.component.css'
})
export class HomeComponent implements OnInit{

  customPurple : string = '#6D50E3';

  linkId: string = '';

  paymentServs: Array<PaymentMethod> = [];
  
  info: LinkInformation | null = null;
  
  constructor(
    private router: Router, 
    private route:ActivatedRoute, 
    private paymentServ: PaymentService, 
    private linkServ: LinkService,
  ){}

  pusherServ = inject(PusherService)

  ngOnInit(): void {

    this.pusherServ.listen(
      'paymentss',
      'payment-push',
      (data:any)=>{
        console.log(`Push: ${data}`)

      }
    )

    this.pusherServ.listen(
      'paymments',
      'payment-qrcode',
      (data:any)=>{
        console.log(`QrCode: ${data}`)
      }
    )

    this.paymentServ.makePayment();

    this.linkServ.clear()

    this.linkId = this.route.snapshot.paramMap.get('linkId')!

    localStorage.setItem('linkId', this.linkId);
 
    this.paymentServ.getLinkInformation(this.linkId).subscribe({
        next: (data) => {

          if( data.status !== LinkStatus.PENDING && data.status !== LinkStatus.ACTIVE ){
            this.router.navigate([data.status?.toLowerCase()])
          }

          this.info = data
          this.linkServ.setLinkInformation(data)
        },
        error: (error) =>{
          this.router.navigate(['not-found'])
        }    
      }
    );
    

    this.paymentServ.getAvailablePaymentServices().subscribe({
       next: data => {
        this.paymentServs = data

        this.paymentServs.forEach(
          paymentSer => {
            switch(paymentSer.name){
              case "iMali": 
                paymentSer.color = "#FFFFFF";
                break;
              case "eMola": 
                paymentSer.color = "#F37227"
                break;
              case "mKesh": 
                paymentSer.color = "#FFD200"
                break;
              case "MPesa": 
                paymentSer.color = "#E70101"
                break;
            }
          }
        )
      } 
    });
    
  }
}